import {useState} from 'react';
import PropTypes from 'prop-types';
import './RemoveComparableDialog.scss';
import {Button, Dialog, DialogActions, DialogContent} from '@mui/material';
import {Cancel, Delete} from '@mui/icons-material';
import SigIconButton from 'components/SigIconButton/SigIconButton';

const RemoveComparableDialog = ({ onConfirmation }) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  function onTriggerClick(event) {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
    event.preventDefault();
  }

  function onCancelDelete(event) {
    event.preventDefault();
    setIsDeleteDialogOpen(false);
  }

  function onConfirmDelete(event) {
    event.preventDefault();
    onConfirmation();
    setIsDeleteDialogOpen(false);
  }

  return (
    <div className="RemoveComparableDialog" data-testid="RemoveComparableDialog">
      <SigIconButton
        className="delete-column"
        title="Click to remove this comparable"
        icon={<Delete classes={{ root: 'delete-image' }} />}
        buttonProps={{
          edge: 'end',
          size: 'small',
          'aria-label': 'delete property button',
          onClick: onTriggerClick,
        }}
      />
      <Dialog
        classes={{ root: 'remove-modal' }}
        open={isDeleteDialogOpen}
        disableScrollLock={true}
        onClose={onCancelDelete}
      >
        <DialogContent>Remove the selected comparable from the report?</DialogContent>
        <DialogActions>
          <Button
            classes={{ root: 'remove-button' }}
            variant="contained"
            startIcon={<Delete />}
            onClick={onConfirmDelete}
          >
            Remove
          </Button>
          <Button
            classes={{ root: 'cancel-button' }}
            variant="contained"
            startIcon={<Cancel />}
            onClick={onCancelDelete}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

RemoveComparableDialog.propTypes = {
  onConfirmation: PropTypes.func.isRequired,
};

RemoveComparableDialog.defaultProps = {};

export default RemoveComparableDialog;
